/** Favorite Dances demo state — localStorage-backed; platform demo shell stays in demoExperience.js */

const DEMO_FIXTURE_TOTAL_PICKS = 5;

export function createDemoFavoriteDancesActions({
  getState,
  setState,
  getWelcomeAttendees,
  writeState,
}) {
  return {
    getState,
    optIn() {
      const state = getState();
      const next = {
        ...state,
        favorite_dances_opted_in: true,
        favorite_dances_skipped: false,
      };
      writeState(next);
      setState(next);
      return next;
    },
    decline() {
      const state = getState();
      const next = {
        ...state,
        favorite_dances_opted_in: false,
        favorite_dances_skipped: true,
      };
      writeState(next);
      setState(next);
      return next;
    },
    submit(voteeIds) {
      const state = getState();
      const next = {
        ...state,
        votes_submitted: true,
        votee_ids: voteeIds,
        checked_out_at: state.checked_out_at || new Date().toISOString(),
      };
      writeState(next);
      setState(next);
      return next;
    },
    getWelcomeAttendees,
    getVoteAttendees(state) {
      if (state.favorite_dances_opted_in !== true) return [];
      return getWelcomeAttendees(state);
    },
    getEventTotalPicks(state) {
      let total = DEMO_FIXTURE_TOTAL_PICKS;
      if (state?.votes_submitted && Array.isArray(state.votee_ids)) {
        total += state.votee_ids.length;
      }
      return total;
    },
    getMyAppreciationsReceived(state) {
      if (!state?.my_rsvp?.dancer_id) return 0;
      let received = 2;
      if (state?.votes_submitted) received += 1;
      return received;
    },
    getCrewDistinctCount(state) {
      return Array.isArray(state?.votee_ids) ? state.votee_ids.length : 0;
    },
    getCrewHighlightMembers(state) {
      const attendees = getWelcomeAttendees(state);
      const byId = new Map(attendees.map((person) => [person.dancer_id, person]));
      return (state?.votee_ids || [])
        .map((id) => byId.get(id))
        .filter(Boolean)
        .map((person) => ({
          dancer_id: person.dancer_id,
          name: person.name,
          thumbnail_url: person.thumbnail_url || null,
        }));
    },
    getAggregate(state) {
      const total = createDemoFavoriteDancesActions({
        getState: () => state,
        setState: () => {},
        getWelcomeAttendees,
        writeState: () => {},
      }).getEventTotalPicks(state);
      if (total < 5) return null;
      return {
        total_votes: total,
        message: `✨ ${total} favorite dances were shared from last night.`,
      };
    },
  };
}

export function getDemoEventTotalPicks(state) {
  let total = DEMO_FIXTURE_TOTAL_PICKS;
  if (state?.votes_submitted && Array.isArray(state.votee_ids)) {
    total += state.votee_ids.length;
  }
  return total;
}

export function getDemoMyAppreciationsReceived(state) {
  if (!state?.my_rsvp?.dancer_id) return 0;
  let received = 2;
  if (state?.votes_submitted) received += 1;
  return received;
}

export function getDemoAggregate(state) {
  const total = getDemoEventTotalPicks(state);
  if (total < 5) return null;
  return {
    total_votes: total,
    message: `✨ ${total} favorite dances were shared from last night.`,
  };
}

export function canDemoVote(state) {
  return Boolean(state?.floor_attended_at && !state?.checked_in_at && !state?.votes_submitted);
}
